"use client";

/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
} from "@/components/ui";
import { Path, UseFormReturn } from "react-hook-form";
type CustomInputProps<TFormValues extends Record<string, any>> = {
  form: UseFormReturn<TFormValues>;
  name: Path<TFormValues>;
  label?: string;
  description?: string;
  helpText?: string;
  className?: string;
};
export type FormInputProps<TFormValues extends Record<string, any>> =
  CustomInputProps<TFormValues> &
    Omit<React.InputHTMLAttributes<HTMLInputElement>, "form" | "name">;
export function FormInput<TFormValues extends Record<string, any>>({
  form,
  name,
  label,
  description,
  placeholder,
  required = false,
  type = "text",
  className,
  ...props
}: FormInputProps<TFormValues>) {
  return (
    <div className={className}>
      <FormField
        control={form.control}
        name={name}
        render={({ field }) => (
          <FormItem>
            {label ? (
              <FormLabel className="tw:text-sm tw:font-semibold tw:gap-0">
                {label}
                {required ? <span className="tw:text-destructive">*</span> : ""}
              </FormLabel>
            ) : null}
            <FormControl>
              <Input
                {...field}
                type={type}
                placeholder={placeholder}
                required={required}
                value={field.value === 0 ? "" : field.value}
                onChange={(e) => {
                  const rawValue = e.target.value;
                  let value;
                  if (type === "number") {
                    // Convert to number or set to empty string if the value is 0
                    value = rawValue === "" ? "" : Number(rawValue);
                    value = value === 0 ? "" : value;
                  } else {
                    value = rawValue;
                  }
                  field.onChange(value);
                }}
                {...props}
              />
            </FormControl>
            {description ? (
              <FormDescription>{description}</FormDescription>
            ) : null}
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
